shadow$provide[242] = function(require,module,exports) {
var require$_DOT__SLASH_array_DOT_js = require("./array.js");
var require$_DOT__SLASH_interval_DOT_js = require("./interval.js");
var require$_DOT__SLASH_latch_DOT_js = require("./latch.js");
var require$_DOT__SLASH_matrix_DOT_js = require("./matrix.js");
var require$_DOT__SLASH_area_DOT_js = require("./area.js");
var require$_DOT__SLASH_voxel_DOT_js = require("./voxel.js");
var require$_DOT__SLASH_volume_DOT_js = require("./volume.js");
var require$_DOT__SLASH_scale_DOT_js = require("./scale.js");
require.exportCopy(module, require$_DOT__SLASH_array_DOT_js);
require.exportCopy(module, require$_DOT__SLASH_interval_DOT_js);
require.exportCopy(module, require$_DOT__SLASH_latch_DOT_js);
require.exportCopy(module, require$_DOT__SLASH_matrix_DOT_js);
require.exportCopy(module, require$_DOT__SLASH_area_DOT_js);
require.exportCopy(module, require$_DOT__SLASH_voxel_DOT_js);
require.exportCopy(module, require$_DOT__SLASH_volume_DOT_js);
require.exportCopy(module, require$_DOT__SLASH_scale_DOT_js);

};